customElements.get('video-reels') ||
  customElements.define(
    'video-reels',
    class extends HTMLElement {
      constructor() {
        super();
        this.activeClass = 'active';
        this.swiperContainer = this.querySelector('.wt-slider__container');
        this.onVideoPlay = this.onVideoPlay.bind(this);
      }

      connectedCallback() {
        this.sectionObserver = null;
        this.initialiseVideos();
        this.observeSection();
        this.waitForSwiper();
      }

      disconnectedCallback() {
        if (this.sectionObserver) {
          this.sectionObserver.disconnect();
          this.sectionObserver = null;
        }

        if (this.checkInterval) {
          clearInterval(this.checkInterval);
        }

        this.querySelectorAll('video').forEach((video) => {
          video.removeEventListener('play', this.onVideoPlay);
        });
      }

      initialiseVideos() {
        if (!this.swiperContainer.dataset.sound) {
          this.swiperContainer.dataset.sound = 'off';
        }

        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.muted = true;
          video.removeAttribute('autoplay');
          video.autoplay = false;
          video.preload = 'none';
          video.setAttribute('preload', 'none');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');

          if (video.dataset.reelsOptimised !== 'true') {
            video.dataset.reelsOptimised = 'true';
            video.addEventListener('play', this.onVideoPlay);
          }
        });

        this.bindSoundButtons();
      }

      onVideoPlay(event) {
        const selectedVideo = event.currentTarget;

        this.querySelectorAll('video').forEach((video) => {
          if (video !== selectedVideo) {
            video.pause();
          }
        });

        selectedVideo.muted = this.swiperContainer.dataset.sound !== 'on';
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      bindSoundButtons() {
        this.querySelectorAll('.wt-video__sound-toggle').forEach((button) => {
          if (button.dataset.soundBound === 'true') return;

          button.dataset.soundBound = 'true';
          button.addEventListener('click', (event) => {
            event.preventDefault();

            const slide = button.closest('[data-swiper-slide]');
            const video = slide?.querySelector('video');
            if (!video) return;

            const soundWillBeEnabled = this.swiperContainer.dataset.sound !== 'on';
            this.swiperContainer.dataset.sound = soundWillBeEnabled ? 'on' : 'off';
            video.muted = !soundWillBeEnabled;

            if (video.paused) {
              video.play().catch(() => {});
            }
          });
        });
      }

      observeSection() {
        this.sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                this.pauseAllVideos();
              }
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
          }
        );

        this.sectionObserver.observe(this);
      }

      waitForSwiper() {
        this.checkInterval = setInterval(() => {
          const swiper = this.swiperContainer?.swiper;
          const isReady = this.swiperContainer?.classList.contains('swiper-initialized');

          if (!swiper || !isReady) return;

          swiper.on('slideChange', () => {
            const activeSlide = swiper.slides[swiper.activeIndex];

            swiper.slides.forEach((slide) => {
              slide.classList.toggle(this.activeClass, slide === activeSlide);

              if (slide !== activeSlide) {
                slide.querySelector('video')?.pause();
              }
            });
          });

          /* Une seconde initialisation prend aussi en charge les éventuelles
             diapositives dupliquées par le mode loop de Swiper. */
          this.initialiseVideos();
          clearInterval(this.checkInterval);
        }, 250);
      }
    }
  );